<template>
    <layout>
        <div class="page">
            <loading v-if="!$store.getters.portfolioLoaded" />
            <div v-else class="work-container uk-margin-large-top">
                <h2 class="uk-heading-primary yellow uk-margin-bottom">Work</h2>
                <div class="work-container-overlay uk-grid-small uk-child-width-1-1 uk-child-width-1-2@s uk-child-width-1-4@m uk-text-center" uk-grid>
                    <portfolio-category-tile
                        v-for="(category, i) in portfolioCategories" :key="i"
                        :name="category.name"
                        :slug="category.slug"
                        :href="`/work/${category.slug}`"
                        :color="category.color">
                    </portfolio-category-tile>
                </div>
            </div>
        </div>
    </layout>
</template>

<script>
import PortfolioCategoryTile from '@/components/PortfolioCategoryTile'
import UIkit from 'uikit'

export default {
    name: 'work',
    components: {
        PortfolioCategoryTile
    },
    computed: {
        menuFields () {
            if (this.$store.state.menus.loaded) {
                const menus = { ...this.$store.getters.menus }
                return menus['work'].fields.menuList
            }
            return null
        },
        portfolioCategories () {
            const categories = []
            if (this.menuFields) {
                this.menuFields.forEach(element => {
                    const obj = {
                        name: element.fields.categoryName ? element.fields.categoryName : '',
                        slug: element.fields.categorySlug ? element.fields.categorySlug : '',
                        color: element.fields.categoryColour ? element.fields.categoryColour.fields.colourSlug : '',
                        image: (element.fields.categoryImage) ? element.fields.categoryImage.fields.file.url : null
                    }
                    categories.push(obj)
                })
            }
            return categories
        }
    },
    created () {
        if (!this.$store.getters.portfolio.loaded) {
            this.$store.dispatch('getPortfolio')
        }
    }
}
</script>

<style lang="scss" scoped>
    
    .page {
        background-image: url('/static/img/work-background.jpg');
        background-size: 300%;
        background-attachment: fixed;
        background-repeat: no-repeat;
        @include mq($from: medium) {
            background-size: 100%;
        }
        &:after {
            content: '';
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: $base-overlay;
            z-index: 0;
        }
        h2 {
            position: relative;
            z-index: 1;
        }
    }
    .dropdown-menu {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 98;
        transform: translateY(-100%);
        transition: 0.4s ease-in-out;
        opacity: 0;

        &.active {
            opacity: 1;
            transition: 0.4s ease-in-out;
            transform: translateY(0%);
        }
    }

    .work-container {
        width: 100%;
        height: 100%;
        padding: 1rem 1rem 0;
    }
</style>



// WEBPACK FOOTER //
// src/pages/work/index.vue